export default __webpack_public_path__ + "SolutionImage5.455ae93.png";